import React from 'react';
import './Table.css';
// import * as Constants from 'Components/App/Constants.js';


export default function Table(props) {

	const x = props.x;

	const renderCount = React.useRef(0);
	const tableContent = React.useRef(null);
	const rows = React.useRef([]);
	const lastRow = React.useRef(0);
	const rawData = React.useRef([]);
	const [content, setContent] = React.useState('');
	const [resultSet, setResultSet] = React.useState([]);
	const [filters, setFilters] = React.useState({});

	const filterableColumns = (typeof props.filterableColumns === 'undefined') ? [] : props.filterableColumns;

	const addCloseButton = (typeof props.addcloseButton === 'undefined') ? false : props.addcloseButton;
	const addDeleteRow = (typeof props.addDeleteRow === 'undefined') ? false : props.addDeleteRow;
	const addEditRow = (typeof props.addEditRow === 'undefined') ? false : props.addEditRow;
	const deleteRowAllowed = (typeof props.deleteRowAllowed === 'undefined') ? false : props.deleteRowAllowed;
	const display = (typeof props.hideTable === 'undefined') ? '' : (props.hideTable) ? 'd-none' : '';
	const onAddColumn = (typeof props.onAddColumn === 'undefined') ? (key, value) => { return key } : props.onAddColumn;
	const onAddFooter = (typeof props.onAddFooter === 'undefined') ? () => { return null } : props.onAddFooter;
	const onAddHeader = (typeof props.onAddHeader === 'undefined') ? () => { return null } : props.onAddHeader;
	const onLoad = (typeof props.onLoad === 'undefined') ? () => { return null } : props.onLoad;
	const onRowClasses = (typeof props.onRowClasses === 'undefined') ? () => { return '' } : props.onRowClasses;
	const onRowEdit = (typeof props.onRowEdit === 'undefined') ? () => { } : props.onRowEdit;
	const onRowClick = (typeof props.onRowClick === 'undefined') ? onRowEdit : props.onRowClick;
	const onRowDelete = (typeof props.onRowDelete === 'undefined') ? (e, rowFields, rowId) => { rowDelete(rowId) } : props.onRowDelete;
	const draggableRows = (typeof props.draggableRows === 'undefined') ? false : props.draggableRows;
	const onReorder = (typeof props.onReorder === 'undefined') ? null : props.onReorder;
	const dragIndex = React.useRef(null);
	const loadSequence = React.useRef(0);

	const table = {};
	init();

	React.useEffect(() => {
		if (renderCount.current < props.loadTable) {
			renderCount.current = props.loadTable;
			// console.log('load table' + props.id);
			load();
		}
	});

	React.useEffect(() => {
		if (rawData.current.length > 0) {
			makeTable(applyFilters(rawData.current));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters]);

	function load() {
		const data = onLoad();
		if (data === null) {
			// Sequenznummer je Aufruf - falls listParams sich schnell aendert (z.B.
			// Marketdata-Watchlist-Auswahl direkt nach dem Mounten, bevor die echte
			// Gruppen-ID feststeht), kann eine AELTERE Anfrage NACH einer neueren
			// antworten und deren korrektes Ergebnis sonst mit veralteten/falschen
			// Daten ueberschreiben. Nur die jeweils zuletzt gestartete Anfrage darf
			// das Ergebnis noch uebernehmen.
			loadSequence.current += 1;
			const currentSequence = loadSequence.current;
			const url = 'Backend/webapp.php?module=' + props.module + '&task=' + props.listTask + ((typeof props.listParams === 'undefined') ? '' : props.listParams);
			x.was.axGet(url, (result) => {
				if (currentSequence !== loadSequence.current) {
					return;
				}
				if (result.data['returncode'] === 1) {
					rawData.current = result.data['content'];
					setResultSet(result.data['content']);
					makeTable(applyFilters(result.data['content']));
				}
				else {
					x.wah.addHint('Error while reading table!', false);
				}
			});
		}
		else {
			rawData.current = data;
			setResultSet(data);
			makeTable(applyFilters(data));
		}
	}

	function applyFilters(data) {
		const activeFilters = filterableColumns.filter((key) => (filters[key] || '').trim() !== '');
		if (activeFilters.length === 0) {
			return data;
		}
		return data.filter((item) => activeFilters.every((key) => {
			const filterValue = filters[key].trim().toLowerCase();
			return String(item[key] ?? '').toLowerCase().indexOf(filterValue) !== -1;
		}));
	}

	function handleFilterChange(key, value) {
		setFilters((previous) => ({ ...previous, [key]: value }));
	}

	function rowClicked(e, rowFields, rowId) {
		e.preventDefault();
		if (e.target.getAttribute("deleterow") === '1') {
			if (deleteRowAllowed) {
				x.wau.yesNo("Wirklich löschen?",
					(result) => {
						console.log(result);
						if (result === 1) onRowDelete(e, rowFields, rowId);
						return;
					});
			}
			else {
				x.wah.addHint('Keine Berechtigung!');
			}
		}
		else if (e.target.getAttribute("editrow") === '1') {
			onRowEdit(e, rowFields, rowId);
		}
		else {
			onRowClick(e, rowFields, rowId);
		}
	}


	// Opt-in Drag-and-Drop-Umsortierung (draggableRows-Prop) - native HTML5-
	// Drag-Events statt einer Library, da nur ein Anwendungsfall (Marketdata-
	// Watchlist) das braucht und das Standardverhalten fuer alle anderen
	// Tabellen (Banking, PageStore, Rezepte, ...) unangetastet bleiben soll.
	function rowDragStart(arrayIndex) {
		dragIndex.current = arrayIndex;
	}

	function rowDrop(e, arrayIndex) {
		e.preventDefault();
		const from = dragIndex.current;
		const to = arrayIndex;
		dragIndex.current = null;
		if (from === null || from === to) {
			return;
		}
		reorderRows(from, to);
	}

	function reorderRows(from, to) {
		const newData = [...rawData.current];
		const [moved] = newData.splice(from, 1);
		newData.splice(to, 0, moved);
		rawData.current = newData;
		setResultSet(newData);
		makeTable(applyFilters(newData));
		if (onReorder) onReorder(newData);
	}

	// iOS/Safari unterstuetzt die native HTML5-Drag-and-Drop-API (draggable=
	// "true" + dragstart/dragover/drop-Events) auf Touch-Geraeten grundsaetzlich
	// nicht - dort passiert beim Ziehen mit dem Finger schlicht gar nichts.
	// Eigene, einfache Touch-Umsetzung parallel zu den bestehenden Drag-Events,
	// angehaengt an ein eigenes Greifer-Icon (nicht an die ganze Zeile!) - sonst
	// laesst sich die Tabelle auf einem Touch-Geraet gar nicht mehr scrollen,
	// weil Ziehen zum Umsortieren und vertikales Scrollen dieselbe Richtung
	// haben und nicht anhand der Geste unterscheidbar waeren. Waehrend des
	// Ziehens wird die Zeile per transform sofort mit dem Finger mitbewegt
	// (reines Feedback), die eigentliche Umsortierung passiert wie beim
	// HTML5-Pendant erst bei touchend.
	const touchStartPos = React.useRef({ x: 0, y: 0 });
	const touchMoved = React.useRef(false);
	const draggedRowEl = React.useRef(null);

	function rowTouchStart(e, arrayIndex) {
		const touch = e.touches[0];
		touchStartPos.current = { x: touch.clientX, y: touch.clientY };
		touchMoved.current = false;
		dragIndex.current = arrayIndex;
		draggedRowEl.current = e.currentTarget.closest('.table-row');
	}

	function rowTouchMove(e) {
		if (dragIndex.current === null) return;
		const touch = e.touches[0];
		const dx = touch.clientX - touchStartPos.current.x;
		const dy = touch.clientY - touchStartPos.current.y;
		if (!touchMoved.current && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
			touchMoved.current = true;
			if (draggedRowEl.current) draggedRowEl.current.classList.add('table-row-dragging');
		}
		if (touchMoved.current) {
			if (e.cancelable) e.preventDefault();
			if (draggedRowEl.current) draggedRowEl.current.style.transform = `translateY(${dy}px)`;
		}
	}

	function rowTouchEnd(e) {
		if (dragIndex.current === null) return;
		const from = dragIndex.current;
		if (draggedRowEl.current) {
			draggedRowEl.current.style.transform = '';
			draggedRowEl.current.classList.remove('table-row-dragging');
		}
		if (touchMoved.current) {
			const touch = e.changedTouches[0];
			const target = document.elementFromPoint(touch.clientX, touch.clientY);
			const targetRow = target ? target.closest('.table-row') : null;
			if (targetRow && targetRow.dataset.rowIndex !== undefined) {
				const to = parseInt(targetRow.dataset.rowIndex, 10);
				if (to !== from) {
					reorderRows(from, to);
				}
			}
			if (e.cancelable) e.preventDefault();
		}
		dragIndex.current = null;
		touchMoved.current = false;
		draggedRowEl.current = null;
	}

	function rowDelete(rowId) {
		const url = 'Backend/webapp.php?module=' + props.module + '&task=' + props.deleteTask
		x.was.axPost(url, { "id": rowId }, (result) => {
			if (result.data['returncode'] === 1) {
				load();
			}
			else {
				x.wah.addHint('Fehler beim Löschen der Rubrik!', true);
			}
		})
	}

	function addFooter(content, columnClass) {
		table.rowFooterCount++
		if (typeof columnClass == 'undefined') {
			columnClass = '';
		}
		table.rowFooter.push(<span
			key={table.rowFooterCount}
			className={`column footer-column ${columnClass}  ${(table.rowFooterCount > 1) ? 'multicolumn' : ''} footer-column-${table.rowFooterCount}`}
		>
			{content}
		</span>);
	}

	function addHeader(content, columnClass) {
		table.rowHeaderCount++
		if (typeof columnClass == 'undefined') {
			columnClass = '';
		}
		table.rowHeader.push(
			<span
				key={table.rowHeaderCount}
				className={`column header-column ${columnClass}  ${(table.rowHeaderCount > 1) ? 'multicolumn' : ''} header-column-${table.rowHeaderCount}`}
			>
				{content}
			</span>);
	}

	function makeFilterRow() {
		if (filterableColumns.length === 0 || rawData.current.length === 0) {
			return null;
		}
		const cells = [];
		let columnCount = 1;
		if (draggableRows) {
			cells.push(<span key="filter-column-drag-handle" className="column filter-column drag-handle-column"></span>);
			columnCount++;
		}
		Object.entries(rawData.current[0]).forEach(([key, value]) => {
			const column = onAddColumn(key, value);
			if (column === false) {
				return;
			}
			const isFilterable = filterableColumns.includes(key);
			cells.push(
				<span
					key={"filter-column-" + columnCount}
					className={`column filter-column ${(columnCount > 1) ? 'multicolumn' : ''} filter-column-${columnCount}`}
				>
					{isFilterable &&
						<span className="table-filter-input-wrap">
							<input
								type="text"
								className="table-filter-input"
								placeholder="Filtern…"
								value={filters[key] || ''}
								onChange={(e) => handleFilterChange(key, e.target.value)}
							/>
							<i
								className={`bi bi-x-circle table-filter-clear ${(filters[key] || '') === '' ? 'd-none' : ''}`}
								title="Filter zurücksetzen"
								onClick={() => handleFilterChange(key, '')}
							></i>
						</span>
					}
				</span>
			);
			columnCount++;
		});
		return cells;
	}

	function makeTable(data = resultSet) {
		init();
		const row = [];
		let columnTags = [];
		let columnCount = 1;
		let rowCount = 1;
		let rowClasses;

		if (draggableRows) addHeader(<i className="bi bi-grip-vertical drag-handle-icon" />, 'drag-handle-column');
		onAddHeader(addHeader);
		onAddFooter(addFooter);

		data.forEach(
			function (item, arrayIndex) {
				let rowId = null;
				columnCount = 1;

				// Add Columns
				columnTags = [];
				if (draggableRows) {
					columnTags.push(
						<span
							key={"table-column-" + rowCount + "-" + columnCount}
							className={`column column-${columnCount} drag-handle-column`}
							onTouchStart={(e) => rowTouchStart(e, arrayIndex)}
							onTouchMove={(e) => rowTouchMove(e)}
							onTouchEnd={(e) => rowTouchEnd(e)}
						>
							<i className="bi bi-grip-vertical drag-handle-icon" />
						</span>
					);
					columnCount++;
				}
				Object.entries(item).forEach(([key, value]) => {
					const column = onAddColumn(key, value);
					if (rowId === null) {
						rowId = value;
					}
					if (column !== false) {
						columnTags.push(
							<span
								key={"table-column-" + rowCount + "-" + columnCount}
								className={`column column-${columnCount} ${(columnCount > 1) ? 'multicolumn' : ''}`}
								title={(typeof column === 'object') ? '' : column}
							>
								{column}
							</span>
						);
						columnCount++;
					}
				});

				// Add Edit Column
				if (addEditRow) {
					columnTags.push(
						<span
							key={"table-column-" + rowCount + "-" + columnCount}
							className={`column column-${columnCount} ${(columnCount > 1) ? 'multicolumn' : ''}`}
						>
							<i
								className="bi bi-pencil"
								editrow="1"
							/>
						</span>);
					columnCount++;
				}

				// Add Delete Column
				if (addDeleteRow) {
					columnTags.push(
						<span
							key={"table-column-" + rowCount + "-" + columnCount}
							className={`column column-${columnCount} ${(columnCount > 1) ? 'multicolumn' : ''}`}
						>
							<i
								className="bi bi-trash3"
								deleterow="1"
							/>
						</span>);
				}

				// Add Row
				lastRow.current = rowCount;
				rowClasses = onRowClasses(item);
				rows.current[rowCount] = React.createRef();
				row.push(
					<div
						key={props.id + "-table-row-" + rowCount}
						id={"table-row-" + rowCount}
						ref={rows.current[rowCount]}
						onClick={(e) => rowClicked(e, item, rowId)}
						draggable={draggableRows}
						data-row-index={draggableRows ? arrayIndex : undefined}
						onDragStart={draggableRows ? () => rowDragStart(arrayIndex) : undefined}
						onDragOver={draggableRows ? (e) => e.preventDefault() : undefined}
						onDrop={draggableRows ? (e) => rowDrop(e, arrayIndex) : undefined}
						className={`table-row ${rowClasses} ${draggableRows ? 'table-row-draggable' : ''} `}
					>
						{columnTags}
					</div>
				)
				rowCount++;
			}
		)

		const headerTag = makeHeaderTag((typeof props.customFilterRow !== 'undefined') ? props.customFilterRow : makeFilterRow());
		const footerTag = makeFooterTag();
		const content =
			<div id={props.id} key="table" className={`table-basis ${props.classes} ${display}`} >
				{headerTag}
				<div key="table-content" className='table-content' ref={tableContent}>
					{row}
				</div>
				{footerTag}
			</div>
		setContent(content);
	}

	function makeHeaderTag(filterRow) {
		if (table.rowHeader.length > 0) {
			if (addCloseButton) addHeader(<i className="bi bi-x-lg table-icon" onClick={e => x.wab[props.id].hide()} />, 'table-close-button');
			if (addEditRow) addHeader(<i className="bi bi-pencil" />);
			if (addDeleteRow) addHeader(<i className="bi bi-trash3" />);
			return (
				<div key="table-header" className='table-header'>
					<div key="table-header-row"
						className={` table-header-row
										${(typeof props.headerClass == 'undefined')
								? ''
								: props.HeaderClass} ${(table.rowHeaderCount < 2) ? 'table-header-center' : 'table-header-left'} `
						}>
						{table.rowHeader}
					</div>
					{filterRow &&
						<div key="table-filter-row" className="table-filter-row">
							{filterRow}
						</div>
					}
				</div>
			)
		}
		else {
			return null;
		}
	}

	function makeFooterTag() {
		if (table.rowFooter.length > 0) {
			return (
				<div key="table-footer"
					className={` table-footer 
							${(typeof props.footerClass == 'undefined')
							? ''
							: props.footerClass}  `
					}>
					{table.rowFooter}
				</div>
			)
		}
		else {
			return null;
		}
	}

	function init() {
		table.rowHeader = [];
		table.rowFooter = [];
		table.rowHeaderCount = 0;
		table.rowFooterCount = 0;
	}

	return (
		<>
			{content}
		</>
	);

}
